// CÓDIGO ISOLADO - NÃO PODE FALHAR
(function() {
  
  // Espera a página carregar completamente
  window.addEventListener('load', function() {
    
    // Procura TODOS os botões possíveis
    var botoes = document.querySelectorAll('button, input[type="submit"], a.btn, .btn');
    var botaoComprar = null;
    
    // Encontra o botão que tem texto "COMPRAR"
    for (var i = 0; i < botoes.length; i++) {
      var texto = (botoes[i].textContent || botoes[i].value || '').toUpperCase();
      if (texto.includes('COMPRAR') || texto.includes('BUY NOW') || texto.includes('COMPRE')) {
        botaoComprar = botoes[i];
        break;
      }
    }
    
    // Se não achou, procura por data attributes
    if (!botaoComprar) {
      botaoComprar = document.querySelector('[data-buy-now], [name="checkout"], .shopify-payment-button__button');
    }
    
    // Se ainda não achou, DESISTE e avisa
    if (!botaoComprar) {
      console.error('❌ Botão COMPRAR AGORA não encontrado');
      return;
    }
    
    console.log('✅ Botão encontrado e isolado:', botaoComprar);
    
    // CLONA o botão para remover TODOS os eventos anteriores
    var novoBotao = botaoComprar.cloneNode(true);
    botaoComprar.parentNode.replaceChild(novoBotao, botaoComprar);
    
    // Agora adiciona NOSSO evento no botão LIMPO
    novoBotao.addEventListener('click', function(e) {
      
      // PREVINE TUDO
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      console.log('🟢 CLIQUE CAPTURADO - Iniciando processo');
      
      // MUDA O BOTÃO IMEDIATAMENTE
      novoBotao.disabled = true;
      novoBotao.style.opacity = '0.6';
      novoBotao.style.pointerEvents = 'none';
      
      // Salva conteúdo original
      var originalContent = novoBotao.innerHTML;
      
      // Cria o HTML de carregamento
      novoBotao.innerHTML = '<span style="display:flex;align-items:center;justify-content:center;gap:10px;">' +
        '<span style="display:inline-block;width:20px;height:20px;border:3px solid rgba(255,255,255,0.3);border-top-color:white;border-radius:50%;animation:spin2 0.8s linear infinite;"></span>' +
        'Preparando seu pedido...</span>';
      
      // Adiciona animação
      if (!document.getElementById('spin-animation')) {
        var style = document.createElement('style');
        style.id = 'spin-animation';
        style.textContent = '@keyframes spin2{to{transform:rotate(360deg)}}';
        document.head.appendChild(style);
      }
      
      // Pega o ID da variante
      var variantInput = document.querySelector('input[name="id"], select[name="id"]');
      var variantId = variantInput ? variantInput.value : null;
      
      if (!variantId) {
        // Tenta pegar de um data attribute
        variantId = novoBotao.getAttribute('data-variant-id') || 
                    document.querySelector('[data-variant-id]')?.getAttribute('data-variant-id');
      }
      
      if (!variantId) {
        console.error('❌ ID da variante não encontrado');
        novoBotao.innerHTML = 'Erro: variante não encontrada';
        setTimeout(function() {
          novoBotao.disabled = false;
          novoBotao.style.opacity = '1';
          novoBotao.style.pointerEvents = 'auto';
          novoBotao.innerHTML = originalContent;
        }, 2000);
        return;
      }
      
      console.log('📦 Variant ID:', variantId);
      
      // USA XMLHttpRequest DIRETO (mais compatível)
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      
      // Timeout de 5 segundos
      var timeout = setTimeout(function() {
        console.warn('⏰ Timeout - redirecionando mesmo assim');
        novoBotao.innerHTML = '✓ Redirecionando...';
        setTimeout(function() {
          window.location.href = '/checkout';
        }, 200);
      }, 5000);
      
      xhr.onload = function() {
        clearTimeout(timeout);
        
        if (xhr.status >= 200 && xhr.status < 300) {
          console.log('✅ Adicionado ao carrinho com sucesso');
          novoBotao.innerHTML = '✓ Redirecionando...';
          
          setTimeout(function() {
            window.location.href = '/checkout';
          }, 150);
        } else {
          console.error('❌ Erro HTTP:', xhr.status);
          novoBotao.innerHTML = 'Erro! Tente novamente';
          novoBotao.style.backgroundColor = '#dc3545';
          
          setTimeout(function() {
            novoBotao.disabled = false;
            novoBotao.style.opacity = '1';
            novoBotao.style.pointerEvents = 'auto';
            novoBotao.style.backgroundColor = '';
            novoBotao.innerHTML = originalContent;
          }, 2000);
        }
      };
      
      xhr.onerror = function() {
        clearTimeout(timeout);
        console.error('❌ Erro de rede');
        novoBotao.innerHTML = 'Erro de conexão';
        novoBotao.style.backgroundColor = '#dc3545';
        
        setTimeout(function() {
          novoBotao.disabled = false;
          novoBotao.style.opacity = '1';
          novoBotao.style.pointerEvents = 'auto';
          novoBotao.style.backgroundColor = '';
          novoBotao.innerHTML = originalContent;
        }, 2000);
      };
      
      // ENVIA A REQUISIÇÃO
      var data = JSON.stringify({
        id: variantId,
        quantity: 1
      });
      
      console.log('📤 Enviando:', data);
      xhr.send(data);
      
      return false;
    });
    
    console.log('✅ Evento de compra instalado com sucesso');
  });
  
})();